<template>
  <div class="user_all">
    <div class="user_search">
      <div class="user_search_item">
        <span>系统类型</span>
        <el-select style="width:100px" v-model="app" :placeholder="this.$t('title.please_choose')">
          <el-option
            v-for="item in appOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="user_search_item">
        <span>环境类型</span>
        <el-select style="width:100px" v-model="env" :placeholder="this.$t('title.please_choose')">
          <el-option
            v-for="item in envOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="user_search_item">
        <span>币类型</span>
        <el-select style="width:100px" v-model="valueType" :placeholder="this.$t('title.please_choose')">
          <el-option
            v-for="item in valueTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <!-- <div class="user_search_item">
        <span>选择日期</span>
        <el-date-picker
          style="width:250px"
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyyMMdd"
        ></el-date-picker>
      </div> -->
      <div class="user_search_item">
        <el-button
          type="primary"
          style="margin-left: 5%"
          @click="this.search"
          :loading="isResponse"
        >{{ $t('title.search') }}</el-button>
      </div>
      <div class="user_search_item" style="display: flex">
        <el-button type="primary" @click="this.getSyncXkMerchantAccount" :loading="isResponse">同步TKM</el-button>
        <el-button
          type="primary"
          style="margin-left: 5%"
          @click="this.getSyncXkProject"
          :loading="isResponse"
        >同步XTO</el-button>
      </div>
    </div>
    <div class="con_table">
      <el-table
        :data="tableData"
        border
        style="width: 100%;margin-bottom: 30px;margin-top: 20px;min-height: 529px"
        :header-cell-style="this.tableHeaderColor"
      >
        <el-table-column :label="this.$t('title.Serial_number')" fixed align="center" width="90" prop="id"></el-table-column>
        <el-table-column label="系统类型" width="90" align="center" prop="app">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.app == 1 ? '钱包' :
              scope.row.app == 2 ? '芯客' :
              scope.row.app == 3 ? '电商' :
              scope.row.app == 4 ? '联盟链' : ''
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="环境类型" width="90" align="center" prop="env">
          <template slot-scope="scope">
            <span>{{scope.row.env == 1 ? '生产' : scope.row.env == 2 ? '测试' : "预发布"}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务器请求host" width="200" align="center" prop="url"></el-table-column>
        <el-table-column label="表主键id" width="90" align="center" prop="itemId"></el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" width="90" align="center" prop="chainId"></el-table-column>
        <el-table-column fixed :label="this.$t('title.name')" width="150" align="center" prop="name"></el-table-column>
        <el-table-column  label="同步表名称" width="150" align="center" prop="item"></el-table-column>
        <el-table-column label="描述" width="150" align="center" prop="description"></el-table-column>
        <el-table-column label="币类型" width="90" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.valueType == 1 ? 'TKM' : 'XTO'}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="XTO余额" width="90" align="center" prop="xtos"></el-table-column>
        <el-table-column fixed="right" label="TKM余额" width="90" align="center" prop="value"></el-table-column>
        <el-table-column fixed="right" label="总的xto个数" width="90" align="center" prop="totalValue"></el-table-column>
        <el-table-column fixed="right" label="阈值" width="90" align="center" prop="thresholdValue"></el-table-column>
        <el-table-column :label="this.$t('title.address')" width="400" align="center" prop="address">
          <template slot-scope="scope">
            <span>{{scope.row.address}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.address)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.state')" width="90" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.status == 0 ? '不足' : '有效'}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Creation_time')" width="190" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getrpcserver,
  getchaininfo,
  userlList,
  getpageAccount,
  syncXkMerchantAccount,
  syncXkProject
} from "../../../api/interface";

export default {
  name: "User",
  components: {},
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      isResponse: false,
      dateValue: [],
      appOptions: [
        {
          value: 1,
          label: "钱包 "
        },
        {
          value: 2,
          label: "芯客"
        },
        {
          value: 3,
          label: "电商"
        },
        {
          value: 4,
          label: "联盟链"
        }
      ],
      app: "",
      envOptions: [
        {
          value: 1,
          label: "生产"
        },
        {
          value: 2,
          label: "测试"
        },
        {
          value: 3,
          label: "预发布",
        }
      ],
      env: "",
      valueTypeOptions: [
        {
          value: 1,
          label: "TKM"
        },
        {
          value: 10,
          label: "XTO创建"
        },
        {
          value: 11,
          label: "XTO管理"
        },
        {
          value: 12,
          label: "XTO销毁"
        }
      ],
      valueType: ""
    };
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.isResponse = true;
      this.getTableData();
    },
    currentPageChange(e) {
      this.currentPage = e;
      this.getTableData();
    },
    getTableData() {
      let data = {
        app: this.app,
        env: this.env,
        valueType: this.valueType,
        startDate: '',
        endDate: '',
        page: this.currentPage,
        rows: 10
      };
      getpageAccount(data).then(response => {
        this.isResponse = false;
        if (response.code == 200) {
          this.tableData = response.data.data;
          console.log(this.tableData);
          this.total = response.data.total;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    getSyncXkMerchantAccount() {
      syncXkMerchantAccount().then(res => {
        if (res.code == 200) {
          this.$message.success("同步成功");
          this.getTableData();
        }
      });
    },
    getSyncXkProject() {
      syncXkProject().then(res => {
        if (res.code == 200) {
          this.$message.success("同步成功");
          this.getTableData();
        }
      });
    }
  },

  created() {
    this.getTableData();
  }
};
</script>
<style scoped lang="scss">
.user_all {
  padding: 20px 30px;
}

.user_search {
  display: flex;
  flex-wrap: wrap;
  .user_search_item {
    margin: 10px 15px;
    span {
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
